import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import {MatSort, MatSortModule} from '@angular/material/sort';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner'
import {MatCell, MatColumnDef, MatHeaderCell, MatHeaderRow, MatRow, MatTableDataSource, MatTableModule} from '@angular/material/table'
import { HttpErrorResponse } from '@angular/common/http';
import { Router, RouterModule } from '@angular/router';
import { EmitterService } from '../../../Shared/Services/emitter.service';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { map, Subscription } from 'rxjs';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';

@Component({
    selector: 'app-exception-summary-count-list',
    imports: [MatSortModule, MatPaginatorModule, MatRow, MatHeaderRow, RouterModule, MatCell, TitleCasePipe, MatHeaderCell, MatColumnDef, MatTableModule, MatProgressSpinnerModule],
    templateUrl: './exception-summary-count-list.component.html',
    styleUrls: ['./exception-summary-count-list.component.scss']
})

export class TotalexceptionComponent implements OnInit, OnDestroy {
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  HTTPOpenExceptionListAPI: any;
  isLoadingResults = true;
  isRateLimitReached = false;
  displayedColumns = ["exception_Code", "exception_Description", "count"];
  CATReporterIMID: any = "";
  Label = "Total";
  Date = "Null";
  dataSource = new MatTableDataSource();
  public redirectUrl: any = "true";
  rowcount: any | undefined = 50;
  currentPage: number = 0;
  subscription!: Subscription;
  constructor(
    private router: Router,
    private UrlsService: UrlsService,
    private UserService: UserService,
    private SharedHttpClientService: SharedHttpClientService,
    private EmitterService: EmitterService) {
  }

  getOPenExceptionCount(_CATReporterIMID: any, Label: string, Date: string) {
    this.Label = Label;
    this.isLoadingResults = true;
    if(this.HTTPOpenExceptionListAPI) {
      this.HTTPOpenExceptionListAPI.unsubscribe();
    }
    this.HTTPOpenExceptionListAPI = this.SharedHttpClientService.get(
      this.UrlsService.setAPIURl1(
        APIURL.MD_Exception_Summary_count_List,
        this.UserService.getActiveMPID() + "/" + Label + "/" + Date))
      .pipe(map((response: Response) => {
        this.isLoadingResults = false;
        return response;
      })).subscribe((Element: any) => {
        if (Element == null) {
          Element = [{ count: "", exception_Code: "", exception_Description: "No Data" }];
          this.dataSource.data = Element
        }
        // Element.push({ count: "0", exception_Code: "0012", exception_Description: "CAT Exception" })
        this.dataSource.data = Element;

      },
        (err: HttpErrorResponse) => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
        });
  }

  ngAfterViewInit() {
    this.getOPenExceptionCount(this.CATReporterIMID, this.Label, this.Date)
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  setMenu(code: any) {
    if (code === '0002' || (this.Label).toLocaleLowerCase() === ("Front Running").toLocaleLowerCase()) {
      this.EmitterService.setActiveMenu.emit({ MenuId: 2, MenuName: 'Surveillance', SubMenuName: 'Front-Running', exceptionCode: code, page: 'Dashboard' });

    }
    else if (code === '0003' || (this.Label).toLocaleLowerCase() === ("Reg SHO").toLocaleLowerCase()) {
      this.EmitterService.setActiveMenu.emit({ MenuId: 2, MenuName: 'Surveillance', SubMenuName: 'Reg-SHO', exceptionCode: code, page: 'Dashboard' });

    }
    else if (code === '0004' || (this.Label).toLocaleLowerCase() === ("Market Abuse").toLocaleLowerCase()) {
      this.EmitterService.setActiveMenu.emit({ MenuId: 2, MenuName: 'Surveillance', SubMenuName: 'Market-Abuse', exceptionCode: code, page: 'Dashboard' });

    }
    else if (code === '0014' || (this.Label).toLocaleLowerCase() === ("CAT").toLocaleLowerCase()) {
      this.EmitterService.setActiveMenu.emit({ MenuId: 0, MenuName: 'CAT', SubMenuName: 'Finra-Exception', exceptionCode: code, page: 'Dashboard' });
    }

    else if (code === '0013' || (this.Label).toLocaleLowerCase() === ("Client Data").toLocaleLowerCase()) {
      this.EmitterService.setActiveMenu.emit({ MenuId: 4, MenuName: 'My-Data-Viewer', SubMenuName: 'Client-Data-Exception', exceptionCode: code, page: 'Dashboard' });
    }

  }

  Route(code: any) {
    let param = '';    
        if ((this.Label).toLocaleLowerCase() === ("Total").toLocaleLowerCase()) {
          if(this.Date !=='Null') {
            param = this.Date
          } else {
            param = 'Null'
          }
         }
        else  {
      param = this.Date + '/' + code;
    }

    if (code === '0002' || (this.Label).toLocaleLowerCase() === ("Front Running").toLocaleLowerCase()) {
      this.redirectUrl = '/pages/Surveillance/Front-Running/' + param;
    }
    else if (code === '0003' || (this.Label).toLocaleLowerCase() === ("Reg SHO").toLocaleLowerCase()) {
      this.redirectUrl = '/pages/Surveillance/Reg-SHO/' + param;
    }
    else if (code === '0004' || (this.Label).toLocaleLowerCase() === ("Market Abuse").toLocaleLowerCase()) {
      this.redirectUrl = '/pages/Surveillance/Market-Abuse/' + param;
    }
    else if (code === '0014' || (this.Label).toLocaleLowerCase() === ("CAT").toLocaleLowerCase()) {
      this.redirectUrl = '/pages/CAT/Finra-Exception/' + param;
    }
    else if (code === '0013' || (this.Label).toLocaleLowerCase() === ("Client Data").toLocaleLowerCase()) {
      this.redirectUrl = '/pages/My-Data-Viewer/Client-Data-Exception/' + param;
    }
    else if ((this.Label).toLocaleLowerCase() === ("CAIS").toLocaleLowerCase()) {
      /* Catch User Action Log */
        this.UserService.logUserActivity("Reviewed CAIS Records", "Dashboard", {
          'Text1': this.UserService.userFirstName + ' reviewed CAIS records from Dashboard',
          'Text2': 'User Filter Parameters: ' + JSON.stringify({ MenuName: 'CAIS', SubMenuName: 'Exception', exceptionCode: code, page: 'Dashboard' })
        });

      this.redirectUrl = '/pages/CAIS/Exception/' + param;
    }
    else {
      this.redirectUrl = '/pages/MainDashboard';
    }
  }

  pageChanged(event: PageEvent) {
    this.currentPage = event.pageIndex;
  }

  ngOnInit() {
    this.subscription = this.EmitterService.getOpenExceptionCount.subscribe(getOpenExceptionCount => {
      this.Label = getOpenExceptionCount.Label;
      this.Date=getOpenExceptionCount.Date;
      this.getOPenExceptionCount(this.CATReporterIMID, getOpenExceptionCount.Label, getOpenExceptionCount.Date)
    });
    this.subscription = this.EmitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getOPenExceptionCount(this.CATReporterIMID, 'TOTAL', 'NULL')
      }
    });
  }

  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }
}